const Strategy = require('../Strategy');
const roundNumber = require('../Utility/RoundNumber');

class StrategyReversePartialPercentage extends Strategy {
    constructor() {
        super();
    }

    getTaxAmount(policy, amount) {
        amount = parseFloat(amount);

        let rules = policy.rules;
        let taxAmount = 0;
        let remainingAmount = amount;

        for (let i = 0; i < rules.length; i++) {
            let rule = rules[i];

            if (rule.minApplyAmountInclude) {
                if (rule.minApplyAmount >= amount) {
                    continue;
                }
            } else {
                if (rule.minApplyAmount > amount) {
                    continue;
                }
            }

            let limitAmount = rule.limitAmount;
            if (!limitAmount) {
                limitAmount = amount;
            }

            let currentAmount = remainingAmount;
            if (amount >= limitAmount) {
                currentAmount = limitAmount - rule.minApplyAmount;
            }

            taxAmount += roundNumber(amount - (currentAmount / (1 + (rule.taxValue / 100))), this.calculationRoundDecimals, rule.roundType);

            // Decrease remaining amount and exit if no money left
            remainingAmount -= currentAmount;
            if (remainingAmount === 0) break;
        }

        return taxAmount;
    }
}

module.exports = new StrategyReversePartialPercentage();